import React from "react";
import "./styles.css";

function Home() {
    return(
   <section className="home" id="home"> 
   <div className="home-content">
    <h1>Hi, It's MUHAMMAD <span>DILSHAIR</span></h1>
    <h3>I'm a <span>MERN Stack Developer</span></h3>
    
    <p className="p-1">Turning ideas into reality with <span>100% energy</span></p>

<div className="social-icons">
    <a href="https://github.com/mdilshair56">
        <i className="bx bxl-github"></i>
    </a>
    <a href="https://www.linkedin.com/in/muhammad-dilshair-zafar">
        <i className="bx bxl-linkedin-square"></i>
    </a>
    <a href="https://www.instagram.com/itxdilshair56">
        <i className="bx bxl-instagram-alt"></i>
    </a>
    <a href="https://x.com/MDILRUBA56IK">
        <i className="bx bxl-twitter"></i>
    </a>
</div>

<div className="btn-group">
    <a href="https://wa.me/+923045808216" className="btn">WhatsApp</a>
    <a href="mailto:mdilrubazafar92@gmail.com" className="btn">Email</a>
</div>

</div>

   <div className="home-img">
   <img className="img1" src={require('./my-pic.png')} alt="MyImage" />
   </div>

   </section>
    )
}
 
export default Home;
